import * as React from "react"
import { DrawerSeeker, GridSeeker, IconSeekers, SimpleCardSeeker, LinkSeeker } from "ui-seeker/core"
import { useTranslation } from "react-i18next"
import { formatDateI18n } from "app/@utils/dateLocale"

import { ALERTS } from 'app/@common/constants'
import {useContextSelector} from "use-context-selector";
import {AppDatesContext} from "../providers";


export default function NotificationsDrawer({ data, openNotifications, setOpenNotifications }) {
    const { t } = useTranslation('layout')
    const monthYear = useContextSelector(AppDatesContext, ({state}) => state.monthYear)

    const config = {
        isOpen: openNotifications,
        controller: setOpenNotifications,
        title: t('notifications.title') + (!!monthYear && monthYear !== 'custom' ? ` (${formatDateI18n(monthYear, { isString: true, format: 'MMM yyyy', receivedFormat: 'yyyyMM' })})` : ''),
        okBtn: false, cancelBtn: false,
        size: 'xs',
        className: 'drawer-form-user'
    }

    const alertTypeMap = {
        [ALERTS.TYPE.COMPETITION]: { name: 'COMPETITION', icon: 'tachometer-alt-fast' },
        [ALERTS.TYPE.PARITY_META]: { name: 'PARITY META', icon: 'balance-scale' },
        [ALERTS.TYPE.PARITY_OTA]: { name: 'PARITY OTA', icon: 'balance-scale' },
        [ALERTS.TYPE.PACKAGES]: { name: 'PACKAGES', icon: 'plane' },
        [ALERTS.TYPE.RATE_CONDITIONS]: { name: 'RATE CONDITIONS', icon: 'percentage' }
    }
    
    const getObjAlertType = key => alertTypeMap[key] || null

    const getStringTp = id => {
        if ([ALERTS.PARITY_META, ALERTS.PARITY_OTA, ALERTS.COMPETITION, ALERTS.PACKAGES].includes(id)) return ALERTS.RATES
        if ([ALERTS.NA_META, ALERTS.NA_OTA, ALERTS.COMPETITION_NA, ALERTS.PACKAGES_NA].includes(id)) return ALERTS.AVAILABILITY
        return null
    }

    return <DrawerSeeker {...config}>
        <GridSeeker spacing={2} container>
            { !data?.typology_available?.length && <GridSeeker size={12} style={{ textAlign: 'center' }}>{t('notifications.empty')}</GridSeeker> }
            { data?.typology_available?.map((a, i) => (<GridSeeker key={i} size={12} className="alert-name">
                <SimpleCardSeeker className={`badge ${_colorFactory(a.toLowerCase())}`} style={{ width: '100%' }}>
                    <div style={{ display: 'flex' }}>
                        <IconSeekers icon={getObjAlertType(a).icon} iconType="fontAwesome" iconWeight="fas" style={{ fontSize: '16px' }} />
                        <div style={{ margin: '0 0 10px 5px', borderBottom: '0.5px solid white', width: '100%' }}>{getObjAlertType(a).name}</div>
                    </div>

                    { Object.entries(data.alerts_notifications[a]).map(([key, alerts], i) => {
                        return <div key={i}>
                            <div style={{ marginTop: i !== 0 ? '5px' : 0 }}>{ getStringTp(key) }</div>

                            { alerts.map((alert, i) => {
                                return <LinkSeeker key={i} href={`/alerts-notifications?tp=${key}`} style={{ display: 'flex', alignItems: 'center', margin: '0 0 2px 10px', color: '#FFF' }}>
                                    <IconSeekers icon='dot-circle' iconType="fontAwesome" iconWeight="fas" style={{ fontSize: '10px', marginRight: '5px' }} /> { alert.alert_name }
                                    <span style={{ minWidth: '20px', textAlign: 'center', backgroundColor: '#fa3e3e', borderRadius: '50%', color: '#FFF', padding: '3px', fontSize: '9px', marginLeft: '5px' }}>{ alert.num }</span>
                                </LinkSeeker>
                            }) }
                        </div>
                    })}
                </SimpleCardSeeker>
            </GridSeeker>)) }
        </GridSeeker>
    </DrawerSeeker>
}

const _colorFactory = features => {
    const colors = {
        [ALERTS.TYPE.COMPETITION]: 'badge-success',
        [ALERTS.TYPE.PARITY_OTA]: 'badge-info',
        [ALERTS.TYPE.PARITY_META]: 'badge-sunday',
        [ALERTS.TYPE.PACKAGES]: 'badge-sandy',
        [ALERTS.TYPE.RATE_CONDITIONS]: 'badge-papaya',
    }

    return colors[features] || ''
}